export const teamMembers = [
  {
    id: 1,
    name: 'Ardi Hoxha',
    position: {
      sq: 'CEO & Founder',
      en: 'CEO & Founder'
    },
    image: '/team/ceo.jpg',
    bio: {
      sq: '10+ vite eksperiencë në web development dhe digital marketing. Pasion për të ndihmuar bizneset të rriten online.',
      en: '10+ years experience in web development and digital marketing. Passion for helping businesses grow online.'
    },
    skills: ['Strategy', 'Leadership', 'Business Development'],
    social: {
      linkedin: '#',
      twitter: '#',
      email: 'ardi@contenta.marketing'
    }
  },
  {
    id: 2,
    name: 'Elira Dervishi',
    position: {
      sq: 'Creative Director',
      en: 'Creative Director'
    },
    image: '/team/creative.jpg',
    bio: {
      sq: 'Specialist në UI/UX design me fokus në user experience dhe brand identity. Fitues i shumë çmimeve të design-it.',
      en: 'UI/UX design specialist focused on user experience and brand identity. Winner of multiple design awards.'
    },
    skills: ['UI/UX Design', 'Branding', 'Creative Strategy'],
    social: {
      linkedin: '#',
      dribbble: '#',
      email: 'elira@contenta.marketing'
    }
  },
  {
    id: 3,
    name: 'Gentian Krasniqi',
    position: {
      sq: 'Lead Developer',
      en: 'Lead Developer'
    },
    image: '/team/developer.jpg',
    bio: {
      sq: 'Full-stack developer me ekspertizë në React, Node.js, dhe cloud technologies. Ndërton aplikacione të shkallëzueshme dhe të sigurta.',
      en: 'Full-stack developer with expertise in React, Node.js, and cloud technologies. Builds scalable and secure applications.'
    },
    skills: ['React', 'Node.js', 'Cloud Architecture'],
    social: {
      github: '#',
      linkedin: '#',
      email: 'gentian@contenta.marketing'
    }
  },
  {
    id: 4,
    name: 'Blerta Shehu',
    position: {
      sq: 'Marketing Strategist',
      en: 'Marketing Strategist'
    },
    image: '/team/marketing.jpg',
    bio: {
      sq: 'Expert në digital marketing me fokus në SEO, social media, dhe content marketing. Data-driven approach për rezultate maksimale.',
      en: 'Digital marketing expert focused on SEO, social media, and content marketing. Data-driven approach for maximum results.'
    },
    skills: ['SEO', 'Social Media', 'Analytics'],
    social: {
      linkedin: '#',
      twitter: '#',
      email: 'blerta@contenta.marketing'
    }
  }
];

export const companyValues = [
  {
    icon: '🎯',
    title: {
      sq: 'Fokus në Rezultate',
      en: 'Results-Focused'
    },
    description: {
      sq: 'Çdo projekt fillon me qëllime të qarta dhe matet me rezultate konkrete.',
      en: 'Every project starts with clear goals and is measured by concrete results.'
    }
  },
  {
    icon: '💡',
    title: {
      sq: 'Inovacion',
      en: 'Innovation'
    },
    description: {
      sq: 'Përdorim teknologjitë më të reja dhe praktikat më të mira të industrisë.',
      en: 'We use the latest technologies and industry best practices.'
    }
  },
  {
    icon: '🤝',
    title: {
      sq: 'Partnership',
      en: 'Partnership'
    },
    description: {
      sq: 'Nuk jemi thjesht një agjenci - jemi partneri juaj strategjik për sukses.',
      en: 'We\'re not just an agency - we\'re your strategic partner for success.'
    }
  },
  {
    icon: '⚡',
    title: {
      sq: 'Shpejtësi & Cilësi',
      en: 'Speed & Quality'
    },
    description: {
      sq: 'Delivery i shpejtë pa kompromentuar cilësinë e punës.',
      en: 'Fast delivery without compromising work quality.'
    }
  }
];

export const companyMilestones = [
  {
    year: '2020',
    title: {
      sq: 'Themelimi',
      en: 'Founded'
    },
    description: {
      sq: 'Contenta Marketing u themelua me misionin për të ndihmuar bizneset shqiptare të rriten online.',
      en: 'Contenta Marketing was founded with the mission to help Albanian businesses grow online.'
    }
  },
  {
    year: '2021',
    title: {
      sq: '50+ Klientë',
      en: '50+ Clients'
    },
    description: {
      sq: 'Arritëm 50 klientë të kënaqur dhe zgjeruam ekipin në 5 persona.',
      en: 'Reached 50 satisfied clients and expanded team to 5 people.'
    }
  },
  {
    year: '2022',
    title: {
      sq: 'Çmimi "Best Agency"',
      en: 'Best Agency Award'
    },
    description: {
      sq: 'Fitues i çmimit "Best Digital Agency" në Albanian Business Awards.',
      en: 'Winner of "Best Digital Agency" at Albanian Business Awards.'
    }
  },
  {
    year: '2023',
    title: {
      sq: '100+ Projekte',
      en: '100+ Projects'
    },
    description: {
      sq: 'Kryem 100+ projekte të suksesshme dhe hapëm zyrë të re.',
      en: 'Completed 100+ successful projects and opened new office.'
    }
  },
  {
    year: '2024',
    title: {
      sq: 'Ekspansion Rajonal',
      en: 'Regional Expansion'
    },
    description: {
      sq: 'Filluam të punojmë me klientë nga Kosova, Maqedonia, dhe Greqia.',
      en: 'Started working with clients from Kosovo, Macedonia, and Greece.'
    }
  },
  {
    year: '2025',
    title: {
      sq: '€500K+ Revenue',
      en: '€500K+ Revenue'
    },
    description: {
      sq: 'Arritëm €500K revenue vjetor dhe ekip prej 15 profesionistësh.',
      en: 'Reached €500K annual revenue and team of 15 professionals.'
    }
  }
];

export const companyStats = [
  { label: { sq: 'Vite Eksperiencë', en: 'Years Experience' }, value: '6+' },
  { label: { sq: 'Klientë të Kënaqur', en: 'Happy Clients' }, value: '150+' },
  { label: { sq: 'Projekte të Përfunduara', en: 'Projects Completed' }, value: '200+' },
  { label: { sq: 'Ekip Profesionistësh', en: 'Team of Professionals' }, value: '15' },
  { label: { sq: 'Revenue i Gjeneruar për Klientë', en: 'Revenue Generated for Clients' }, value: '€2M+' },
  { label: { sq: 'Kënaqësi e Klientëve', en: 'Client Satisfaction' }, value: '98%' }
];